/**
 * Summarize + Cull Prompts
 *
 * Prompts for summarization, relevance scoring, and harvest drafting.
 *
 * @module config/prompts/summarize-cull-prompts
 */
// ═══════════════════════════════════════════════════════════════════════════
// SUMMARIZE + CULL PROMPTS
// ═══════════════════════════════════════════════════════════════════════════
export const SUMMARIZE_BRIEF = {
    id: 'SUMMARIZE_BRIEF',
    name: 'Brief Summary',
    description: 'Generate a concise 1-3 sentence summary of the given text.',
    template: `Summarize the following text in 1-3 sentences. Be concise and capture the core meaning.

Text:
{{text}}

Summary:`,
    requirements: {
        capabilities: [],
        temperature: 0.3,
        maxTokens: 256,
    },
    version: 1,
    usedBy: ['transform'],
};
export const SUMMARIZE_DETAILED = {
    id: 'SUMMARIZE_DETAILED',
    name: 'Detailed Summary',
    description: 'Generate a detailed summary preserving key points and structure.',
    template: `Provide a detailed summary of the following text. Preserve key arguments, examples, and structure. Use bullet points for distinct ideas.

Text:
{{text}}

Detailed Summary:`,
    requirements: {
        capabilities: [],
        temperature: 0.3,
        maxTokens: 1024,
    },
    version: 1,
    usedBy: ['transform'],
};
export const HARVEST_CULL_RELEVANCE = {
    id: 'HARVEST_CULL_RELEVANCE',
    name: 'Harvest Cull Relevance Scorer',
    description: 'Score the relevance of a harvest item to a project context.',
    template: `You are evaluating whether a piece of harvested content is relevant to a project.

Project context:
{{projectContext}}

Content to evaluate:
{{content}}

Rate this content's relevance on a scale of 0.0 to 1.0, where:
- 0.0 = completely irrelevant, should be culled
- 0.5 = marginally relevant, could go either way
- 1.0 = highly relevant, essential to keep

Respond with ONLY valid JSON:
{"score": <number>, "reasoning": "<brief explanation>", "recommended": "<keep|cull>"}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.2,
        maxTokens: 256,
    },
    version: 1,
    usedBy: ['cull-service'],
};
export const HARVEST_DRAFT_GENERATION = {
    id: 'HARVEST_DRAFT_GENERATION',
    name: 'Harvest Draft Generation',
    description: 'Generate a cohesive chapter draft from harvested passages following a narrative outline.',
    template: `Write a cohesive chapter (~{{wordCount}} words) that weaves these passages into flowing prose.

OUTLINE:
{{outline}}

SOURCE PASSAGES:
{{passages}}

REQUIREMENTS:
1. Follow the outline structure — use it as your guide for ordering and emphasis
2. Weave passages naturally into flowing prose, not as a list
3. Add minimal bridging text where needed for coherence
4. Preserve key ideas, phrasing, and insights from the source material
5. Maintain consistent voice throughout
6. Start with a compelling opening, end with reflection — not summary

Output ONLY the chapter text. No meta-commentary, no explanations.`,
    requirements: {
        capabilities: [],
        temperature: 0.7,
        maxTokens: 8192,
    },
    version: 1,
    usedBy: ['harvest-draft'],
};
export const SUMMARIZE_CULL_PROMPTS = [
    SUMMARIZE_BRIEF,
    SUMMARIZE_DETAILED,
    HARVEST_CULL_RELEVANCE,
    HARVEST_DRAFT_GENERATION,
];
//# sourceMappingURL=summarize-cull-prompts.js.map